const n = (a) => a.replace(/^\/+/, ""), e = n;
export {
  e as u
};
//# sourceMappingURL=unleadingSlashIt-D4xkFtcJ.mjs.map
